import APIClient from '@/shared/http/clients/api'

const resourceName = 'REEmpreendimentoUnidade'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const GetAllByEmpreendimentoId = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetAllByEmpreendimentoId/${id}`, data, config)
const GetAllWithPrecoByEmpreendimentoId = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetAllWithPrecoByEmpreendimentoId/${id}`, data, config)
const GetApartamento = (id, cpf, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetApartamentoById/${id}/${cpf}`, data, config)
const GetAllWithTipoByEmpreendimentoId = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetAllWithTipoByEmpreendimentoId/${id}`, data, config)
const GetAllGroupByEmpreendimento = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetAllGroups/${id}`, data, config)
const GetAllStatus = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetAllStatus`, data, config)
const ChangeUnity = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/Change`, data, config)

const EnterpriseUnityRepository = {
  GetAllByEmpreendimentoId,
  GetAllGroupByEmpreendimento,
  GetApartamento,
  GetAllStatus,
  GetAllWithTipoByEmpreendimentoId,
  ChangeUnity,
  GetAllWithPrecoByEmpreendimentoId
}

export default EnterpriseUnityRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/enterpriseunity.js